<template>
  <Popover
    trigger="click"
    placement="bottomLeft"
    overlayClassName="coope-panel-popover-container"
    :arrow="false"
    :align="{ offset: [-143, 0] }"
    v-model="visible"
    @visibleChange="handleVisibleChange"
  >
    <span :class="labelClasses"
      ><span class="control-label">{{$t('home.Type')}}</span>
      <span class="arrow-icon" :class="{actived: visible}"><SvgIcon icon-class="arrow-left"/></span
    ></span>
    <FlexScrollBox slot="content">
      <div slot="header" style="padding: 32px 32px 24px">
        <IndentInput v-model="searchText" @change="handleSearchTags" allowClear style="height: 42px; font-size: 16px" :placeholder="$t('home.SearchType')" />
      </div>
      <div slot="main" class="tag-group-container">
        <CheckboxGroup v-model="selectedTagIds" class="tag-checkbox-group">
          <Checkbox v-for="tag in tags" :key="tag.id" :value="tag.id">{{tag.name}}</Checkbox>
        </CheckboxGroup>
      </div>
      <div slot="footer" class="control-extra-footer">
        <BasicBtnGroup @primeClick="handleOk" @defClick="handleClearTags">
          <span slot="defContent" style="color: #000">{{$t('common.Clear')}}</span>
        </BasicBtnGroup>
      </div>
    </FlexScrollBox>
  </Popover>
</template>
<script>
import { Popover, Checkbox } from 'ant-design-vue'
import FlexScrollBox from '@/components/behavior/flex-scroll-box/index.vue'
import BasicBtnGroup from '@/components/behavior/basic-btn-group/index.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import IndentInput from '@/components/behavior/indent-input/index.vue'
import { debounce } from '@/utils/ops'

export default {
  name: 'CoopePanelTypeControl',
  props: {
    getPopupContainer: {
      type: Function,
      required: false
    }
  },
  components: {
    Popover,
    Checkbox,
    CheckboxGroup: Checkbox.Group,
    BasicBtnGroup,
    FlexScrollBox,
    IndentInput
  },
  data() {
    return {
      visible: false,
      selectedTagIds: [],
      tags: [],
      searchText: ''
    }
  },
  created() {
    this.syncSearchTags = debounce(text => {
      this.tags = this.getTagsByName(text) || []
    }, 300)

    this.syncSearchTags('')
  },
  beforeDestroy() {
    this.syncSearchTag = null
  },
  computed: {
    ...mapGetters('coc', ['getTagsByName']),
    ...mapState('coc', ['cocsQuery']),
    labelClasses() {
      const { tags = [] } = this.cocsQuery
      return tags.length === 0 ? 'coope-panel-control' : 'coope-panel-control actived'
    }
  },
  methods: {
    ...mapActions('coc', ['reloadCocs']),
    handleOk() {
      this.reloadCocs({ tags: this.selectedTagIds })
      this.visible = false
    },
    handleVisibleChange(visible) {
      if (visible) {
        this.syncSearchTags('')
        const { tags = [] } = this.cocsQuery
        this.selectedTagIds = tags.slice()
      }
    },
    handleSearchTags() {
      this.syncSearchTags(this.searchText)
    },
    handleClearTags() {
      this.selectedTagIds = []
    }
  }
}
</script>
<style scoped lang="less">
@import url(./control.less);
@import url(~@/styles/font.less);
.tag-group-container {
  overflow: hidden;
}
.tag-checkbox-group {
  padding: 0 32px;
  margin: 0 -4px;
  ::v-deep .ant-checkbox-wrapper {
    .regular-font(12);
    color: #1f5edb;
    padding: 2px 0 1px;
    line-height: 17px;
    background: #ebf1ff;
    border-radius: 4px;

    margin: 0 6px 12px;

    &:last-child {
      margin-right: 0;
    }

    & > span {
      display: inline-block ;
      vertical-align: middle;
    }

    &.ant-checkbox-wrapper-checked {
      color: #ffffff;
      background: #236cff;
    }
    & > .ant-checkbox {
      display: none;
    }

  }

}
</style>
